<!-- eslint-disable comma-dangle -->
<!-- eslint-disable quotes -->
<template>
    <span class="svg-icon" v-bind="$attrs">
        <keep-alive>
            <component :is="{ template: iconName }" width="24px" height="24px" :fill="fill" />
        </keep-alive>
    </span>
</template>

<script>
import { icons } from "../../../utils/icons";

export default {
    name: "SvgAsset",
    props: {
        name: {
            type: String,
            required: true,
        },

        width: {
            type: String,
            default: undefined,
        },

        height: {
            type: String,
            default: undefined,
        },

        fill: {
            type: String,
            default: "",
        }, 

        styles: {
            type: [ String, Object ],
            default: undefined,
        },
    },
    computed: {
        iconName() {
            return icons[this.name];
        },
    },
};
</script>

<style lang="scss" scoped>
    .svg-icon {
        border: 1px solid transparent;
        background: rgba(238, 240, 246, 60%);
        border-radius: 50%;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #eff0f7;

        svg {
            fill: #94a4bd;
        }
    }
</style>